import { ButtonsGroup, DefaultValue, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { Alignment } from '../types'

type BulkActionsWrapperProps = {
  align: Alignment
}

export const BulkActionsWrapper = styled.div<BulkActionsWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: ${({ align }) => (align === 'left' ? 'flex-start' : 'flex-end')};
  padding: 0 ${Spacing.S16} ${Spacing.S16};
  border-radius: ${DefaultValue.BorderRadius};
`

export const ButtonsWrapper = styled(ButtonsGroup)`
  margin-left: ${Spacing.S16};
`
